var React = require('react');

function MapPin16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Type=Hitta butik, Invert=off, Size=16x16","stroke":"currentColor"},[React.createElement("path",{"id":"Rectangle 685","d":"M11.975 6.932L8 14.882l-3.975-7.95C2.547 3.977 4.696.5 8 .5c3.304 0 5.453 3.477 3.975 6.432z","fill":"none","key":0}),React.createElement("circle",{"id":"Ellipse 140","cx":"8","cy":"4.5","r":"2","key":1})]));
}

MapPin16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = MapPin16x16;

MapPin16x16.default = MapPin16x16;
